let auth = localStorage.getItem('auth')
auth = auth ? JSON.parse(auth) : {}

let menu = []

if (auth.acesso) menu = auth.acesso.modulos

export default menu
